import api from './api';
import { Customer } from '../types/customer';

export const customerService = {
  async getAllCustomers(): Promise<Customer[]> {
    try {
      const response = await api.get('/customers/list');
      return response.data.customers;
    } catch (error) {
      console.error('顧客一覧の取得に失敗:', error);
      throw error;
    }
  },

  async getCustomerById(ID: number): Promise<Customer> {
    try {
      const response = await api.get(`/customers/${ID}`);
      return response.data;
    } catch (error) {
      console.error('顧客詳細の取得に失敗:', error);
      throw error;
    }
  },

  async createCustomer(customer: Omit<Customer, 'ID'>): Promise<number> {
    try {
      const response = await api.post('/customers', customer);
      return response.data.customerId;
    } catch (error) {
      console.error('顧客の作成に失敗:', error);
      throw error;
    }
  },

  async searchByName(name: string): Promise<Customer[]> {
    try {
      const response = await api.get('/customers/search', { params: { name } });
      return response.data.customers;
    } catch (error) {
      console.error('顧客検索に失敗:', error);
      throw error;
    }
  }
};